import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/interfaces/pcg-table-column.interface';
import { EditAgencyVm, EditAgencyVmFromFg } from '../../HEROS/Models/EditAgencyVm';
import { EditApplicantVm, EditApplicantVmFromFg } from '../../HEROS/Models/EditApplicantVm';

export class EditPublicApplicationVm {
	agency?: EditAgencyVm;
	application?: EditApplicantVm;
	confirmedMessages?: string[];
	recaptchaToken?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'agency': EditAgencyVm.Form,
			'application': EditApplicantVm.Form,
			'confirmedMessages': new UntypedFormControl([], [...(validators['confirmedMessages'] ?? []), ...[]]),
			'recaptchaToken': new UntypedFormControl(null, [...(validators['recaptchaToken'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): EditPublicApplicationVmFromFg {
		return new EditPublicApplicationVmFromFg(fg);
	}
}

export class EditPublicApplicationVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get agency(): EditAgencyVmFromFg {
		return new EditAgencyVmFromFg(this.fg.get('agency') as UntypedFormGroup);
	}
	set agency(val) {
		(this.fg.get('agency') as UntypedFormGroup).setValue(val);
	}

	get application(): EditApplicantVmFromFg {
		return new EditApplicantVmFromFg(this.fg.get('application') as UntypedFormGroup);
	}
	set application(val) {
		(this.fg.get('application') as UntypedFormGroup).setValue(val);
	}

	get recaptchaToken(): string {
		return this.fg.get('recaptchaToken').value;
	}
	set recaptchaToken(val) {
		this.fg.get('recaptchaToken').setValue(val);
	}
}
